import UserDetailModule from './UserDetailModule'
export default UserDetailModule
